export const REFERENCE_TYPE_LABELS = {
  customer_payment: "Customer Payment",
  account_transfer: "Fund Transfer",
  importer_payment: "Importer Payment",
  vendor_payment: "Vendor Payment",
  expense: "Expense",
  loan_given: "Loan Given",
  loan_repayment: "Loan Repayment",
  customer_refund: "Customer Refund",
}

export const humanizeReferenceType = referenceType =>
  REFERENCE_TYPE_LABELS[referenceType] || referenceType || "-"
